import { AutoComplete, Col, Form, Row } from "antd";
import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import "./institution.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedInstitutionCategory extends Component {
  state = {
    categories: [],
  };

  componentDidMount = async () => {
    if (this.props.institutionId) {
      await Axios.get("/1.0.0/game/category", {
        params: { institutionId: this.props.institutionId },
      })
        .then((response) => {
          console.log(response.data);
          this.setState({ categories: response.data });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  submitForm = async () => {
    this.props.next();
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 24,
        },
      },
    };
    return (
      <div>
        <div>
          <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="email"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Row>
              <Col span={18} style={{ padding: "1.5em" }}>
                <Form.Item
                  name="category"
                  rules={[
                    {
                      required: true,
                      message: "Kérem adja meg a kategóriát!",
                    },
                  ]}
                >
                  <AutoComplete
                    id="category"
                    name="category"
                    onChange={(value, option) =>
                      this.props.changeCategory(value, option)
                    }
                    onSelect={this.handleSelectCategory}
                    value={this.props.category}
                    onFocus={this.props.setInputName}
                    style={{ width: "100%" }}
                    className="inst-input-field"
                    placeholder="Kategória"
                  >
                    {this.state.categories.map((category) => {
                      return (
                        <AutoComplete.Option
                          key={category.id}
                          value={category.name}
                        >
                          {category.name}
                        </AutoComplete.Option>
                      );
                    })}
                  </AutoComplete>
                </Form.Item>
              </Col>
              <Col span={4} style={{ padding: "1.5em" }}>
                <Form.Item>
                  <button type="submit" className="inst-next-button">
                    Következő <Right className="inst-arrow-icon" />
                  </button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {/* <Form
            ref={this.props.formRef}
            {...formItemLayout}
            name="company"
            onFinish={this.submitForm}
            scrollToFirstError
            layout="vertical"
            //wrapperCol={{ style: { padding: "0", margin: "0 0 0 0" } }}
          >
            <Form.Item
              label={<strong>Kategória neve:</strong>}
              name="category"
              rules={[
                {
                  required: true,
                  message: "Kérem adja meg a kategóriát!",
                },
              ]}
            >
              <AutoComplete
                id="category"
                name="category"
                onChange={(value, option) =>
                  this.props.changeCategory(value, option)
                }
                onSelect={this.handleSelectCategory}
                value={this.props.category}
                onFocus={this.props.setInputName}
              >
                {this.state.categories.map((category) => {
                  return (
                    <AutoComplete.Option
                      key={category.id}
                      value={category.name}
                    >
                      {category.name}
                    </AutoComplete.Option>
                  );
                })}
              </AutoComplete>
            </Form.Item>
            <Form.Item>
              <Button
                danger
                onClick={this.props.prev}
                style={{ marginRight: "0.5em" }}
              >
                Vissza
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                danger
                style={{ marginLeft: "0.5em" }}
              >
                Következő
              </Button>
            </Form.Item>
          </Form> */}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const InstitutionCategory = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedInstitutionCategory);
export default InstitutionCategory;
